const menuRouter = [
    /**
     * 采购管理
     **/
    {
        path: '/sysmain/monthcheck',
        meta: { title: '每月结账' },
        component: () => import('@/views/page/sysmain/monthcheck'),
        used: true,
    },
    {
        path: '/sysmain/systembackup',
        meta: { title: '数据库备份' },
        component: () => import('@/views/page/sysmain/systembackup'),
        used: true,
    },
    {
        path: '/sysmain/systemenable',
        meta: { title: '系统启用' },
        component: () => import('@/views/page/sysmain/systemenable'),
        used: true,
    },
    {
        path: '/sysmain/systeminit',
        meta: { title: '系统初始化' },
        component: () => import('@/views/page/sysmain/systeminit'),
        used: true,
    }
]

export default menuRouter
